import { Controller } from "@hotwired/stimulus"

// เลือกขั้นราคาในก้อนเดียว แล้วปุ่มซื้อปุ่มเดียวเปลี่ยนตามที่เลือก
// (แทนของเดิมที่เป็นการ์ดละปุ่ม — ทั้งหน้าแพ็กเกจมีปุ่มซื้อ 10 ปุ่ม)
export default class extends Controller {
  static targets = ["option", "input", "button"]
  static values = { ctaPrefix: String }

  connect() {
    const initial = this.optionTargets.find(o => o.dataset.default === "true") || this.optionTargets[0]
    if (initial) this.apply(initial)
  }

  select(event) {
    this.apply(event.currentTarget)
  }

  apply(option) {
    this.optionTargets.forEach(o => {
      const on = o === option
      o.classList.toggle("is-on", on)
      o.setAttribute("aria-checked", on)
    })

    if (this.hasInputTarget) this.inputTarget.value = option.dataset.bundlePackageId
    if (this.hasButtonTarget && option.dataset.ctaLabel) {
      this.buttonTarget.textContent =
        `${this.ctaPrefixValue} ${option.dataset.ctaLabel} · ${option.dataset.price}`.trim() // data-price มาเป็นป้ายราคาตามภาษาแล้ว
    }
  }
}
